export const BRAZIL = 'BRAZIL';
export const HSFS_SEED = 'HSFS_SEED';
export const HSFS_SERIES_A = 'HSFS_SERIES_A';
export const HSFX_ENTREPRENEUR = 'HSFX_ENTREPRENEUR';
export const STRATEGIC_PARTNERSHIP = 'STRATEGIC_PARTNERSHIP';
export const HSFX_BOOTSTRAP = 'HSFX_BOOTSTRAP';
export const LATAM_ES = 'LATAM_ES';
export const LATAM_ES_PRO = 'LATAM_ES_PRO';
export const LATAM_AND_BRAZIL_ES_PRO = 'LATAM_AND_BRAZIL_ES_PRO';
export const SERVICE_PRO_ONBOARDING = 'SERVICE_PRO_ONBOARDING';
export const SALES_PRO_ONBOARDING = 'SALES_PRO_ONBOARDING';
export const MARKETING_BASIC_TO_PRO = 'MARKETING_BASIC_TO_PRO';
export const NO_PROMOTION = 'NO_PROMOTION';
export const RETAIL_STARTER_PRODUCT = 'RETAIL_STARTER_PRODUCT';
export const STARTER_SUMMER_2022 = 'STARTER_SUMMER_2022';
export const CRM_SUITE_STARTER_NEW_2023 = 'CRM_SUITE_STARTER_NEW_2023';
export const CRM_SUITE_STARTER_NEW_SEPTEMBER_2023 = 'CRM_SUITE_STARTER_NEW_SEPTEMBER_2023';
export const CRM_SUITE_STARTER_REGIONAL_NEW_SEPTEMBER_2023 = 'CRM_SUITE_STARTER_REGIONAL_NEW_SEPTEMBER_2023';
export const promotionKeys = {
  BRAZIL,
  HSFS_SEED,
  HSFS_SERIES_A,
  HSFX_ENTREPRENEUR,
  STRATEGIC_PARTNERSHIP,
  HSFX_BOOTSTRAP,
  LATAM_ES,
  LATAM_ES_PRO,
  LATAM_AND_BRAZIL_ES_PRO,
  SERVICE_PRO_ONBOARDING,
  SALES_PRO_ONBOARDING,
  MARKETING_BASIC_TO_PRO,
  NO_PROMOTION,
  RETAIL_STARTER_PRODUCT,
  STARTER_SUMMER_2022,
  CRM_SUITE_STARTER_NEW_2023,
  CRM_SUITE_STARTER_NEW_SEPTEMBER_2023,
  CRM_SUITE_STARTER_REGIONAL_NEW_SEPTEMBER_2023
};